<template>
	<div class="log-teaser">
		<div class="row justify-center relative-position">
			<q-img v-if="teaserImage"
				   class="col-12 col-md-auto log-teaser-image"
				   :src="teaserImage"
				   :alt="logNo"
				   style="width: 100%;"
				   position="50% 100%"
				   ratio="2.666666666666667"
				   contain
			/>
			<q-img v-else
				   class="col-12 col-md-auto log-teaser-image"
				   :src="fallbackImagePath"
				   :alt="logNo"
				   style="width: 100%;"
				   ratio="2.666666666666667"
			>
				<div class="absolute-full text-subtitle2 flex flex-center">
					{{ $t('previewImageUnavailable') }}
				</div>
			</q-img>
			<slot/>
		</div>

    <div class="q-px-md">
      <h5>{{ name }}</h5>
      <span class="subheading">{{ speciesName }}</span>
      <p class="text-secondary" v-if="unavailable">{{ $t('logUnavailable.short') }}</p>
    </div>
	</div>
</template>

<script>
	import Teaser from "@/mixins/Teaser";

	export default {
		name: "LogTeaser",
		mixins: [Teaser],
		props: ['log', 'watchlistItem', 'isPublic'],
		computed: {
			name() {
				return `${this.$t('veneerLog')} ${this.logNo}`;
			}
		}
	}
</script>

<style lang="scss">
	.log-teaser-image {
		background-color: var(--image-placeholder-color);
	}
</style>